import parseErrorStack from 'react-native/Libraries/Core/Devtools/parseErrorStack';

export { parseErrorStack };
